import { Navigate } from 'react-router-dom';
import { SALON_GUEST_INTENT_PATH, SALON_STYLIST_CHECKIN_PATH } from '../config/salonApp';
import { isSalonDeskMode } from '../utils/salonKioskMode';

export default function VisitIntentPage() {
  return (
    <Navigate to={isSalonDeskMode() ? SALON_STYLIST_CHECKIN_PATH : SALON_GUEST_INTENT_PATH} replace />
  );
}
